import { useMemo } from "react";
import { useForm } from "react-hook-form";
import { camelCase } from "lodash";
import Header from "../../components/Header";
import Form from "../../../../../components/shared/Form";
import Content from "./Content";
import { useConfig } from "./Content/config";
import { usePreferenceMutation } from "../../api/usePreferenceMutation";
import { useCompanyPreferences } from "../../hooks/usePreferences";

type Values = Record<string, Record<string, boolean>>;

const options: string[] = [
    "job-information",
    "personal-information",
    "company-information",
    "hiring-information",
    "address",
    "key-dates",
    "organization",
    "status",
    "expected-hours",
    "employment-type",
    "terminate",
    "custom-fields",
];

function People() {
    const config = useConfig();
    const { mutate, isPending } = usePreferenceMutation("company", "peopleApiConnection");
    const peopleApiConnection = useCompanyPreferences("peopleApiConnection");

    const values = useMemo(() => {
        return Object.entries(config).reduce((total, [section, items]) => ({
            ...total,
            [section]: items.reduce((fields, { key }) => ({
                ...fields,
                [key]: peopleApiConnection?.[section]?.[key] ?? false,
            }), {}),
        }), {} as Values);
    }, [config, peopleApiConnection]);

    const form = useForm<Values>({
        defaultValues: values,
        values,
        resetOptions: { keepDirtyValues: true },
    });

    const onFinish = (value: Values) => mutate({ ...peopleApiConnection, ...value });

    return (
        <div className="tw-p-5 tw-h-full tw-bg-white tw-rounded-lg">
            <Form className="tw-h-full" form={form} onFinish={onFinish}>
                <Header name="people" isLoading={isPending} />

                <div className="tw-flex tw-flex-wrap tw-gap-x-20 tw-flex-1 tw-overflow-auto tw-my-4">
                    {options.map((option) => (
                        <Content
                            key={option}
                            name={camelCase(option)}
                            title={option}
                            items={config[camelCase(option)] ?? []}
                        />
                    ))}
                </div>
            </Form>
        </div>
    );
}

export default People;
